import styled, {css} from 'styled-components';

import BaseDropdown, {TProps as TBaseDropdownProps} from '../Dropdown';
import {mixins} from '../styles';

type TDropdownProps = TBaseDropdownProps & {
  minWidth?: string;
};

export const Dropdown = styled(BaseDropdown)<TDropdownProps>`
  ${({theme, minWidth}) => css`
    text-align: center;
    z-index: ${theme.zIndex.footer};
    min-width: ${minWidth ?? 'auto'};
  `}
`;

type TArrowProps = {
  disabled: boolean;
};

export const Arrow = styled.svg<TArrowProps>`
  user-select: none;
  ${mixins.pureButton}
  ${({theme, disabled}) => css`
    color: ${disabled ? theme.palette.grey400 : theme.palette.white};
    pointer-events: ${disabled ? 'none' : 'auto'};
  `};
`;

export const Month = styled.div`
  position: relative;
  padding: ${({theme: {spacing}}) => spacing.s3};
`;

export const Calendar = styled.div`
  ${mixins.f3};
  width: fit-content;
  min-width: 276px;
  ${({theme}) => css`
    box-shadow: ${theme.boxShadow.XS};
    padding-bottom: ${theme.spacing.s3};
    border-radius: ${theme.borderRadius.br2};
  `};
`;

export const Head = styled.div`
  ${mixins.stack({direction: 'ROW', align: 'center', justify: 'space-between', size: '11'})};
  padding: 12px 20px;
  ${({theme}) => css`
    background: ${theme.branding.content.primary};
    color: ${theme.palette.white};
    border-radius: ${theme.borderRadius.br2} ${theme.borderRadius.br2} 0 0;
  `};
`;

export const Content = styled.div`
  ${mixins.stack({size: '8', direction: 'ROW'})};
  ${({theme}) => css`
    color: ${theme.palette.grey900};
    padding: ${theme.spacing.s3} ${theme.spacing.s3} 0 ${theme.spacing.s3};
  `};
`;

export const Actions = styled.div`
  ${mixins.stack({direction: 'ROW', align: 'center', justify: 'end', size: '2'})};
  ${({theme}) => css`
    margin-top: 12px;
    padding: 0 ${theme.spacing.s3};
  `}
`;

export const HeadSection = styled.div<{hasYearSwitchButton?: boolean}>`
  display: grid;
  grid-template-columns: ${({hasYearSwitchButton}) =>
    hasYearSwitchButton ? '52px auto 52px' : '20px auto 20px'};
  width: 100%;

  svg {
    ${mixins.wh('20px')};
  }
`;

export const HeadControls = styled.div`
  ${mixins.stack({direction: 'ROW', align: 'center', justify: 'space-evenly', size: '3'})};
`;

export const HeadDate = styled.div`
  ${mixins.stack({direction: 'ROW', align: 'center', justify: 'center', size: '1'})};
`;

export const DateLink = styled.button`
  ${mixins.pureButton};
  color: inherit;

  &:hover {
    text-decoration: underline;
  }
`;
